
import TitleService from 'title-service';
import './EditProfileTitle.scss';
export default function EditProfileTitle(props: any) {
    return (
        <div className="sc-bWFPNQ bKYUNa ">
            <h2 className="text-color--primary">{TitleService('Edit Profile')}</h2>
        </div>
    );
}